import { useEffect, useState } from "react";
import logo from "../images/flyins-logo.svg";
import { Link } from "@material-ui/core";
import { Axios } from "../utils/UtilityFunctions";

const VerifyRegistration = () => {
  const [isSuccess, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");
    const hash = urlParams.get("hash");

    const verifyAccount = async () => {
      try {
        const response = await Axios("POST", "/auth/verify", {
          id,
          hash,
        });

        if (response.data.success) {
          setSuccess(true);
          setErrorMessage(null);
        } else {
          setSuccess(false);
          setErrorMessage(response.data.error);
        }
      } catch (error) {
        setSuccess(false);
        setErrorMessage("An unexpected error occurred. Please try again.");
        console.log(error);
      }
    };

    verifyAccount();
  }, []);

  return (
    <>
      <div
        className="container"
        style={{
          maxWidth: "90vw",
          margin: "auto",
          height: "calc(100vh - 180px)",
        }}
      >
        <div
          className="logo"
          style={{
            width: "100%",
            margin: "10% 0",
            justifyContent: "center",
            display: "inline-grid",
          }}
        >
          <img src={logo} alt="Flyins logo" />
        </div>
        <div
          className="message"
          style={{ fontSize: 15, fontWeight: 400, color: "#343A40" }}
        >
          {isSuccess ? (
            <>
              <p>Congratulations! </p>
              <p>You have successfully created an account.</p>
            </>
          ) : (
            <>
              <p>Verification failed.</p>
              {errorMessage && <p>{errorMessage}</p>}
            </>
          )}
        </div>
        <Link href="login">
          <button
            style={{
              background: "#005694",
              color: "#fff",
              fontSize: 15,
              fontWeight: 600,
              width: 196,
              height: 44,
              border: "none",
              borderRadius: 22,
              cursor: "pointer",
            }}
          >
            Proceed to login page
          </button>
        </Link>
      </div>
    </>
  );
};

export default VerifyRegistration;
